interface GridOverlayProps {
  isEditMode: boolean
  cols: number
  width: number
  rowHeight: number
  gridMargin: number
  numRows?: number
}

export default function GridOverlay({
  isEditMode,
  cols,
  width,
  rowHeight,
  gridMargin,
  numRows = 25,
}: GridOverlayProps) {
  if (!isEditMode) return null

  const columnWidth = (width - gridMargin * (cols + 1)) / cols

  const verticalGutters = []

  verticalGutters.push(
    <div
      key="v-gutter-left"
      className="absolute top-0 bottom-0"
      style={{
        left: 0,
        width: `${gridMargin}px`,
        backgroundColor: 'rgba(51, 153, 243, 0.08)',
      }}
    />
  )

  for (let i = 0; i < cols - 1; i++) {
    const left = gridMargin + (i + 1) * columnWidth + i * gridMargin
    verticalGutters.push(
      <div
        key={`v-gutter-${i}`}
        className="absolute top-0 bottom-0"
        style={{
          left: `${left}px`,
          width: `${gridMargin}px`,
          backgroundColor: 'rgba(51, 153, 243, 0.08)',
        }}
      />
    )
  }

  verticalGutters.push(
    <div
      key="v-gutter-right"
      className="absolute top-0 bottom-0"
      style={{
        right: 0,
        width: `${gridMargin}px`,
        backgroundColor: 'rgba(51, 153, 243, 0.08)',
      }}
    />
  )

  const horizontalGutters = []

  horizontalGutters.push(
    <div
      key="h-gutter-top"
      className="absolute left-0 right-0"
      style={{
        top: 0,
        height: `${gridMargin}px`,
        backgroundColor: 'rgba(51, 153, 243, 0.08)',
      }}
    />
  )

  for (let i = 0; i < numRows; i++) {
    const top = gridMargin + (i + 1) * rowHeight + i * gridMargin
    horizontalGutters.push(
      <div
        key={`h-gutter-${i}`}
        className="absolute left-0 right-0"
        style={{
          top: `${top}px`,
          height: `${gridMargin}px`,
          backgroundColor: 'rgba(51, 153, 243, 0.08)',
        }}
      />
    )
  }

  const verticalLines = []
  for (let i = 0; i <= cols; i++) {
    const left = gridMargin + i * (columnWidth + gridMargin)

    if (i < cols) {
      verticalLines.push(
        <div
          key={`v-start-${i}`}
          className="absolute top-0 bottom-0 opacity-25"
          style={{
            left: `${left}px`,
            borderLeft: '1px dashed #3399f3',
          }}
        />
      )
    }

    if (i < cols) {
      verticalLines.push(
        <div
          key={`v-end-${i}`}
          className="absolute top-0 bottom-0 opacity-25"
          style={{
            left: `${left + columnWidth}px`,
            borderLeft: '1px dashed #3399f3',
          }}
        />
      )
    }
  }

  const horizontalLines = []
  for (let i = 0; i <= numRows; i++) {
    const top = gridMargin + i * (rowHeight + gridMargin)

    horizontalLines.push(
      <div
        key={`h-start-${i}`}
        className="absolute left-0 right-0 opacity-25"
        style={{
          top: `${top}px`,
          borderTop: '1px dashed #3399f3',
        }}
      />
    )

    horizontalLines.push(
      <div
        key={`h-end-${i}`}
        className="absolute left-0 right-0 opacity-25"
        style={{
          top: `${top + rowHeight}px`,
          borderTop: '1px dashed #3399f3',
        }}
      />
    )
  }

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" style={{ zIndex: 0 }}>
      {verticalGutters}
      {horizontalGutters}
      {verticalLines}
      {horizontalLines}
    </div>
  )
}
